// axios.js
import axios from 'axios';
import auth0Client from '~/plugins/authClient';
import router from '~/router';
import { Routes } from '@/constants/routes';

// TODO this will be deleted in the future as all the resources will be accessed within API Gateway
const instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_API_URL,
  // You can add more default settings here
});

instance.interceptors.request.use(
  async (config) => {
    try {
      const token = await auth0Client.getAccessTokenSilently();
      config.headers.Authorization = `Bearer ${token}`;
    } catch (error) {
      console.error('Error getting access token:', error);
      // Handle error, e.g., by redirecting to login
      router.push(Routes.Login);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export default instance;
